import { registerTheme } from '../../theme';

registerTheme('funnel', {});
